import React from 'react';
import theme from './Cards.module.scss';
import Tags, { TagsProps } from '@/components/Tags';
import { classnames } from '@/utils/html';
import CardRow from './CardRow';
import { Trans } from '@lingui/react/macro';

type CardTagsProps = TagsProps;

const CardTags: React.FC<CardTagsProps> = ({ className, size = 'small', addTags = false, tags, ...rest }) => {
    return (
        <CardRow>
            {tags.length === 0 && (
                <>
                    <span className={classnames(theme.tags, theme.empty)}>
                        <Trans>No Tags</Trans>
                        <Tags addTags={addTags} tags={tags} size={size} {...rest} />
                    </span>
                </>
            )}
            {tags.length !== 0 && (
                <Tags addTags={addTags} className={classnames(theme.tags, className)} tags={tags} size={size} {...rest} />
            )}
        </CardRow>
    );
};

export default CardTags;
